import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table } from "react-bootstrap";
import { getPtoTotalsBySubaccountYtd } from "../../../../apis/pto/Reports";
import Dollars from "../../../common/typeFormatting/Dollars";
import Decimal from "../../../common/typeFormatting/DecimalFmt";
import RevenueTypeSection from "./RevenueTypeSection";
import YearSelect from "../../../common/forms/YearSelect";
import MonthSelect from "../../../common/forms/MonthSelect";
import ExportButton from "../../../common/DataGrids/ExportButton";

const PtoBalanceBySubaccountYtd = () => {
  
    const [isRptLoading, setIsRptLoading] = useState(true);
    const [report, setReport] = useState(null);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth());

    useEffect(() => {
      async function getReport(year, month) {
        var rpt = await getPtoTotalsBySubaccountYtd(year, month);

        rpt.direct.subaccountTotals.sort((a,b) => a.subaccount.localeCompare(b.subaccount));
        rpt.indirect.subaccountTotals.sort((a,b) => a.subaccount.localeCompare(b.subaccount));

        setReport(rpt);
        setIsRptLoading(false);
      }

      getReport(year, month);

    }, [year, month]);

    const handleYearChange = (year) => {
      setYear(year);
    };

    const handleMonthChange = (month) => {
      setMonth(month);
    };

    const headers = [
    {
        key: "revenueType",
        label: "Revenue Type",
        columns: [
            { label: "Revenue Type", key: "revenueType", isNumber: false },
            { label: "Subaccount", key: "subaccount", isNumber: false },
            { label: "Start Hours", key: "prevHoursBalance", isNumber: true },
            { label: "Hours Earned", key: "hoursEarned", isNumber: true },
            { label: "Hours Used", key: "hoursUsed", isNumber: true },
            { label: "Cash Earned", key: "cashEarned", isNumber: true },
            { label: "Cash Used", key: "cashUsed", isNumber: true },
            { label: "Hours Avail.", key: "hoursAvailable", isNumber: true },
            { label: "Cash Avail.", key: "cashAvailable", isNumber: true }
        ]
    }];

    const csvHeaders = headers.flatMap(
      h => h.columns.map(col => ({ label: col.label, key: col.key }))
    );

    return (
      <Container fluid>
        <Row>
          <Col>
            <Card style={{marginTop: 25}}>
              <Card.Body>
                  <Card.Title>PTO Balance By Subaccount YTD</Card.Title>
                  <Row>
                    <YearSelect initialYear={year} onYearChange={handleYearChange} />
                    <MonthSelect initialMonth={month} onMonthChange={handleMonthChange} />
                  </Row>
                  {isRptLoading ?
                    <table><tbody><tr><td>Data is loading...</td></tr></tbody></table>
                    :
                    <>                  
                  <Row>
                    <ExportButton className="table-modifier"
                      data={report.direct.subaccountTotals.concat(report.indirect.subaccountTotals)}
                      headers={csvHeaders}
                      page={"Pto_YTD_BySubaccount_" + year + "_" + month}
                      pageModifier={""}
                    />
                  </Row>
                  <Row>
                  <Table hover responsive style={{fontSize: 12, overflowY: "auto"}} >

                      <RevenueTypeSection revenueSection={report.direct} />
                      <RevenueTypeSection revenueSection={report.indirect} />                    
                      <tfoot>
                        <tr>
                            <td>Grand Total</td>
                            <td className="text-right"><Decimal>{report.grandTotals.startHours}</Decimal></td>
                            <td className="text-right"><Decimal>{report.grandTotals.earnedHours}</Decimal></td>
                            <td className="text-right"><Decimal>{report.grandTotals.usedHours}</Decimal></td>
                            <td className="text-right"><Dollars>{report.grandTotals.earnedDollars}</Dollars></td>
                            <td className="text-right"><Dollars>{report.grandTotals.usedDollars}</Dollars></td>
                            <td className="text-right"><Decimal>{report.grandTotals.hoursAvailable}</Decimal></td>
                            <td className="text-right"><Dollars>{report.grandTotals.cashAvailable}</Dollars></td>
                        </tr>
                      </tfoot>                    
                  </Table>                    
                  </Row>
                    </>
                  }                                 
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );

}

export default PtoBalanceBySubaccountYtd;